import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ApplicationCreationSources } from '../../shared/enums';
import { Lead } from '../../shared/models/login/lead.model';
import { AuthService } from '../../shared/services/auth/auth.service';
import { EncryptionService } from '../../shared/services/auth/encryption.service';
import { DialogService } from '../../shared/services/common/dialog/dialog.service';
import { LocalStoreService } from '../../shared/services/common/local-store/local-store.service';
import { NgwWowService } from 'ngx-wow';
import { PartnerCategory } from '../../shared/models/login/PartnerCategory.model';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { LPRedirectUrl } from '../../shared/models/login/LPRedirectUrl.model';
declare var $: any;

@Component({
	selector: 'app-open-trading-account21',
	templateUrl: './open-trading-account21.component.html',
	styleUrls: ['./open-trading-account21.component.scss']
})
export class OpenTradingAccount21Component implements OnInit {

	lead: Lead = new Lead();
	data: PartnerCategory = new PartnerCategory();
	callInProgress: boolean = false;
	showLoader: boolean = false;
	PartenerCategory: Array<PartnerCategory> = [];
	isLoggedIn: boolean = false;
	showOtp: boolean = false;
	disableOtp: boolean = false;
	encryptedMobile: string;
	 
	showdist: boolean = true;
	
	urldata: LPRedirectUrl = new LPRedirectUrl();

	customOptions: OwlOptions = {
		dots: false,
		nav: false,
		loop: false,
		margin: 20,
		autoplay: false,
		autoplayHoverPause: false,
		touchDrag: false,
		mouseDrag: false,
		pullDrag: false,


		responsive: {
			0: {
				items: 1,
				pullDrag: true,
				touchDrag: true,
				mouseDrag: true,
				dots: true,
			},
			400: {
				items: 2,
				pullDrag: true,
				touchDrag: true,
				mouseDrag: true,
				dots: true,
			},
			991: {
				items: 4
			},
			992: {
				items: 4
			}
		},
	}

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private authService: AuthService,
		private localStore: LocalStoreService,
		private dialogService: DialogService,
		private encryption: EncryptionService,
		private wowService: NgwWowService
	) {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.wowService.init();
	}

	ngOnInit(): void {
        this.data.CategoryCode =='AP';
		$(document).ready(function () {
			$(window).scroll(function () {
				if ($(this).scrollTop() > 50) {
					$("#back-to-top").fadeIn();
				} else {
					$("#back-to-top").fadeOut();
				}
			});
			// scroll body to 0px on click
			$("#back-to-top").click(function () {
				$("body,html").animate(
					{
						scrollTop: 0
					},
					400
				);
				return false;
			});
		});
		$(document).ready(function () {
			$(window).scroll(function () {
				if ($(this).scrollTop() > 450) {
					$(".sticky-cta .sem-oda-form-submit").fadeIn();
				} else {
					$(".sticky-cta .sem-oda-form-submit").fadeOut();
				}
			});
			// scroll body to 0px on click
			$(".sticky-cta .sem-oda-form-submit").click(function () {
				$("body,html").animate(
					{
						scrollTop: 0
					},
					450
				);
				return false;
			});
		});

		 
		this.loadMasters();
		const me = this;

		this.localStore.reset();

		$("body").css('padding-top', 0);

		//Read UTM Parameters
		this.route.queryParams.subscribe(params => {
			me.localStore.saveUtmParams(params);
		});

		$("input[type=tel]").on("focus", function () {
			$(this).on("keyup", function (e) {
				if (/\D/g.test(this.value)) {
					this.value = this.value.replace(/\D/g, '');
				}
			});
		});

		$("#txtOtp").on("focus", function () {
			$(this).on("keyup", function (e) {
				if (/\D/g.test(this.value)) {
					this.value = this.value.replace(/\D/g, '');
				}
			});
		});

		$(".name-inputbox").on("focus", function () {
			$(this).on("keyup", function (e) {
				if (/[^A-Za-z ]/g.test(this.value)) {
					this.value = this.value.replace(/[^A-Za-z ]/g, '');
				}
			});
		});
	}
	keyPressAcceptOnlyChar(event) {

		var inp = String.fromCharCode(event.keyCode);
	
		if (/^[a-zA-Z_ ]*$/.test(inp)) {
		  return true;
		} else {
		  event.preventDefault();
		  $("#txtFullName").val('');
		  this.dialogService.error("Please enter only Characters");
		  return false;
		}
	  }
	loadMasters() {
		// this.authService.getPartnerCategory().subscribe(data => {
		// 	this.PartenerCategory = data;
		// });

		this.authService.lpurldata().subscribe(urldata => {
			this.urldata = urldata;
		});

	}

	generateOtp(isResend: boolean = false) 
    {
		if (!this.lead.Name) {
            this.dialogService.error("Please enter Name.");
            return;
        }
        if (!this.lead.Email) {
            this.dialogService.error("Please enter Email Id.");
            return;
        }
        if (!this.lead.Mobile) {
            this.dialogService.error("Please enter Mobile number.");
            return;
        }
        if (!this.lead.City) {
            this.dialogService.error("Please enter City.");
            return;
        }
        if (this.lead.Mobile.length != 10) {
            this.dialogService.error("Please enter valid Mobile number.");
            return;
        }
        if (!this.lead.agreeTerms) {
            this.dialogService.error("Please select Term  and Conditions.");
            return;
        }
        if (!this.lead.PinCode) {
            this.dialogService.error("Please enter Pincode.");
            return;
        }

        if (this.lead.Email)
            this.lead.Email = this.lead.Email.toLowerCase();

        this.lead.LeadSource = "LP";
        this.lead.UtmSource = this.localStore.data.UtmSource;
		this.lead.UtmTerm = this.localStore.data.UtmTerm;
		this.lead.UtmMedium = this.localStore.data.UtmMedium;
		this.lead.UtmCampaign = this.localStore.data.UtmCampaign;
		this.lead.UtmContent = this.localStore.data.UtmContent;
		this.lead.UtmPromo = this.localStore.data.UtmPromo;
		this.lead.UtmDeviceId = this.localStore.data.UtmDeviceId;
		this.lead.UtmAppid = this.localStore.data.UtmAppid;
		this.lead.UtmAdvertisementId = this.localStore.data.UtmAdvertisementId;
		this.lead.UtmAppsflyerid = this.localStore.data.UtmAppsflyerid;
		this.lead.UtmOSversion = this.localStore.data.UtmOSversion;
		this.lead.UtmATTConsent = this.localStore.data.UtmATTConsent;
		this.lead.LgCode = this.localStore.data.LgCode;
		this.lead.LcCode = this.localStore.data.LcCode;
		this.lead.SourceCode = this.localStore.data.SourceCode;
        this.lead.PartnerCategory = this.data.CategoryCode;
        this.lead.Source = ApplicationCreationSources.HSLDAO;

        if (this.callInProgress) return;
        this.callInProgress = true;
        this.disableOtp = false;
        this.authService.startPartner(this.lead).subscribe(data => {
            this.lead = data;
            this.showOtp = true;

            if (isResend) {
                this.dialogService.success("Otp resent successfully.");
            }
        }, (error) => {
            this.callInProgress = false;
        }, () => {
            this.callInProgress = false;
        });
	}

	onCategorySelected(value: string) {
		this.lead.Name = "";
		this.lead.Email = "";
		this.lead.Otp = "";
		//this.lead.City="";
		this.lead.Name = "";
		this.lead.Mobile = "";
	}

	validateOtp() {
		 
        if (!this.lead.Name) {
            this.dialogService.error("Please enter Name.");
            return;
        }
        if (!this.lead.Email) {
            this.dialogService.error("Please enter Email Id.");
            return;
        }
        if (!this.lead.Mobile) {
            this.dialogService.error("Please enter Mobile number.");
            return;
        }
        if (!this.lead.City) {
            this.dialogService.error("Please enter City.");
            return;
        }
        if (this.lead.Mobile.length != 10) {
            this.dialogService.error("Please enter valid Mobile number.");
            return;
        }
        if (!this.lead.agreeTerms) {
            this.dialogService.error("Please select Term  and Conditions.");
            return;
        }
        if (!this.lead.PinCode) {
            this.dialogService.error("Please enter Pincode.");
            return;
        }
			this.lead.UtmCampaign = 'AP';
			if (this.callInProgress) return;
			this.callInProgress = true;
			this.disableOtp = true;
			this.authService.validatePartnerOtp(this.lead).subscribe(() => {
				//this.dialogService.success("Thank you!");
				//$('#thankYouModal').modal('show');
				this.router.navigateByUrl('/thank-you');
			}, () => {
				this.callInProgress = false;
			}, () => {
				this.callInProgress = false;
			});
 
	}

	enterpincode(event: any) {
		var pin = event.target.value;
        if(pin.length==6)
        {
		if (pin.length == 6 && pin!=" ") {
			var a = this.lead.PinCode = event.target.value;
			this.getstate(a);
			return true;
		}
		else if (pin.length !=0 && pin.length < 6 && pin!=" ") {
			this.lead.City = "";
			return true;
		}
        }
		else {
			return true;
		}
	}

	getstate(pincode) {
		this.authService.getstatename(pincode).subscribe(state => {
			this.lead.Distict = state;
			 
		},
			error => {
				"Something went wrong in pincode state name"
			})
	}
}
